import React from "react";
import Dashboard from "./Dashboard.js";
import information from "../../assets/information.png";
import "./DashboardCommon.css";

const CommissionsDashboard = ({ index, dashboardText, handleDashboardClick, dataList }) => {
  console.log("CommissionsDashboard", dataList);
  if (dataList.length === 0) {
    return <h4>No data</h4>;
  }
  for (const [key, value] of Object.entries(dataList)) {
    console.log('CommissionsDashboard', `${key}: ${value}`);
    for (const [key2, value2] of Object.entries(value)) {
      value2.y = value2.commissions;
    }
  }

  return (
    <>
      <div className="header_flex">
        <h4 className="header_title">Commissions</h4>
        <img className="header_image" src={information} alt="information" />
        <p className="header_description">Commission générée sur la vente des produits</p>
      </div>
      <div className="dashboard_div">
       <Dashboard
          type={index}
          ListType={dashboardText}
          monthList={dataList?.month}
          dayList={dataList?.day}
          weekList={dataList?.week}
        />
      </div>
      <div className="divider_div3" />
    </>
  );
};

export default CommissionsDashboard;
